require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-1-wx-sd-k.json") })
        }
      }, "path---photos-professional-1-wx-sd-k");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-1-wx-sd-k!./.cache/json/photos-professional-1-wx-sd-k.json
// module id = 637
// module chunks = 231608221292675